<template>
  <div
    :class="
      twMerge(
        'relative flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-white',
        $attrs.class,
      )
    "
  >
    <div class="flex h-3.5 w-3.5 items-center justify-center">
      <slot />
    </div>
    <div
      class="absolute top-0 h-full w-full rounded-full border-2 border-black/10"
    />
  </div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>
